import './JobPage.scss'
import { useParams } from "react-router-dom";
import JobCard from '../JobsPage/JobCard';
import usePageTitle from "../../hooks/PageTitle";

export default function JobPage() {
  const { job_id } = useParams();

  usePageTitle("Job");

  return (
    <div className='__job'>
      <div className='content'>
        <JobCard jobId={job_id} />
      </div>
    </div>
  );
}
